import { useTranslation } from 'react-i18next';
import { Button, Column, List, Label, Icon } from 'components';
import { tCurrentDeviceSpec } from 'types/services/devices';
import { tError } from 'types/global';
import { colorBlueBasic, colorRedBasic } from 'styles/GlobalStyles';
import { AddButtonWrapper, ListWrapper } from '../AddEditFormDevices.style';

type tSpecs = {
  disabled?: boolean;
  preview?: boolean;
  openForm: (id: number | null) => void;
  data: tCurrentDeviceSpec[];
  onChange: (data: any) => void;
  errors: tError[];
};

const Specs: React.FC<tSpecs> = ({
  disabled = false,
  preview = false,
  openForm = () => {},
  data: specs,
  onChange,
  errors = [],
}): JSX.Element => {
  const { t } = useTranslation();

  const deleteItem = (id: number) => {
    onChange({ fieldName: 'specifications', label: specs.filter((item) => item.id !== id) });
  };

  const errorNum = errors.map((err) => (err?.loc ? err?.loc[0] : null));
  const items =
    specs?.map((spec, index) => {
      return {
        ...spec,
        error: errorNum.includes(index),
        actions:
          disabled || preview
            ? [
                {
                  action: (
                    <Icon width='1rem' height='1rem' icon='visibility' fill={colorBlueBasic} />
                  ),
                  actionHandler: () => openForm(spec.id),
                },
              ]
            : [
                {
                  action: <Icon width='1rem' height='1rem' icon='edit' fill={colorBlueBasic} />,
                  actionHandler: () => openForm(spec.id),
                },
                {
                  action: <Icon width='1rem' height='1rem' icon='close' fill={colorRedBasic} />,
                  actionHandler: () => deleteItem(spec.id),
                },
              ],
      };
    }) ?? [];

  return (
    <>
      <Column>
        <ListWrapper>
          <Label
            styles={{
              alignItems: 'flex-start',
              marginTop: specs.length > 0 ? '5px' : 0,
              maxWidth: '90px',
            }}
          >
            {t('Device spec')}
          </Label>
          <List items={items} noItemsCopy={t('No device characteristics assigned')} />
        </ListWrapper>
      </Column>
      {!disabled && !preview && (
        <AddButtonWrapper>
          <Button
            icon='addCircle'
            onClick={() => openForm(null)}
            variant='blue'
            disabled={disabled}
          >
            {t('Add')}
          </Button>
        </AddButtonWrapper>
      )}
    </>
  );
};

export default Specs;
